import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<{ fullWidth?: boolean }>`
  width: ${(p) => (p.fullWidth ? '100%' : 'auto')};
  display: flex;
  color: ${(p) => p.theme.palette.grey[700]};
  text-decoration: none;
  :hover {
    color: ${(p) => p.theme.palette.primary[500]};
    text-decoration: underline;
    p {
      color: ${(p) => p.theme.palette.primary[500]};
    }
  }
`;
